/************************* Preact Files ************************/
import { h, Component } from 'preact';
import { connect } from 'preact-redux';

/************************* Custom Component Files ************************/
import Map from '../../components/map';
import AreaChartView from '../../components/areaChart';
import ProjectTimeLine from '../../components/project-timeline';
import DownloadModal from '../downloadModal';
import NoDataTemplate from '../../components/no-data-template';
import { fetchProjectDetailsOnSelection, clearProjectDetails } from '../../../src/shared/actions/projectDetailActions';
import DonutBarChart from '../donutBarChart';
import ProjectDonutBarChart from '../projectDonutBarChart'
/************************* Third Party  Files ************************/
import Helmet from 'preact-helmet';

/************************* Style Files ************************/
import style from './style.scss';
import { dispatch } from 'd3';
class ProjectDescription extends Component {

	constructor(props) {
		super(props);
		this.state = {
			isInfo: false,
			expand: false,
			mapType: 'map',
			prevLocation: { location: '', source: '' },
			currentLocation: { location: '', source: '' },
			nextLocation: { location: '', source: '' },
			showText: false,
			showTextDesc2: false,
			iucnMember: false,
			iucnNonMember: false,
		};
		this.currentLocationIndex = 0;
		this.showNext = false;
		this.showPrev = false;

	}

	componentDidMount = () => {
		let year = this.props.mapCurrentYear
	}

	openModal = (type) => {
		this.setState({ expand: true, maptype: type });
	}

	closeModal = () => {
		this.setState({ expand: false });
	}
	changeSatelliteSrc(currentLocationIndex) {
		this.currentLocationIndex = currentLocationIndex;
		if (this.props.satelliteData && this.props.satelliteData.length) {
			if (this.currentLocationIndex === 0) {
				this.setState({ prevLocation: { location: '', source: '' } });
				this.showPrev = false;
			} else {
				this.setState({ prevLocation: this.props.satelliteData[this.currentLocationIndex - 1] });
				this.showPrev = true;
			}
			this.setState({ currentLocation: this.props.satelliteData[this.currentLocationIndex] });
			if (this.props.satelliteData.length > 1 && this.currentLocationIndex !== this.props.satelliteData.length - 1) {
				this.setState({ nextLocation: this.props.satelliteData[this.currentLocationIndex + 1] });
				this.showNext = true;
			} else {
				this.showNext = false;
			}
		}
	}
	setMapType(type) {
		if (type === 'satellite') {
			this.setState({ mapType: 'satellite' });
			if (this.props.satelliteData && this.props.satelliteData.length) {
				this.setState({ prevLocation: { location: '', source: '' } });
				this.setState({ currentLocation: this.props.satelliteData[this.currentLocationIndex] });
				if (this.props.satelliteData.length > 1) {
					this.setState({ nextLocation: this.props.satelliteData[this.currentLocationIndex + 1] });
					this.showNext = true;
				} else {
					this.showNext = false;
				}
			}
		} else {
			this.setState({ mapType: 'map' });
		}
	}
	changeIframeSrc = (type) => {
		let source = '';
		switch (type) {
			case 'prev':
				if (this.currentLocationIndex > 0) {
					this.currentLocationIndex--;
					if (this.props.satelliteData[this.currentLocationIndex - 1]) {
						this.setState({ prevLocation: this.props.satelliteData[this.currentLocationIndex - 1] });
						this.showPrev = true;
					}
					else {
						this.setState({ prevLocation: { location: '', source: '' } });
						this.showPrev = false;
					}
					this.setState({ currentLocation: this.props.satelliteData[this.currentLocationIndex] });
					this.setState({ nextLocation: this.props.satelliteData[this.currentLocationIndex + 1] });
					source = this.state.currentLocation.source;
				}
				else {
					this.setState({ prevLocation: { location: '', source: '' } });
					this.showPrev = false;
				}
				if (this.state.nextLocation.source)
					this.showNext = true;
				else
					this.showNext = false;

				break;
			case 'next':
				if (this.currentLocationIndex < this.props.satelliteData.length - 1) {
					this.setState({ prevLocation: this.props.satelliteData[this.currentLocationIndex] });
					this.currentLocationIndex++;
					this.setState({ currentLocation: this.props.satelliteData[this.currentLocationIndex] });
					this.setState({ nextLocation: this.props.satelliteData[this.currentLocationIndex + 1] })
					source = this.state.currentLocation.source;
					this.showNext = true;
					if (this.currentLocationIndex === this.props.satelliteData.length - 1) {
						this.setState({ nextLocation: { location: '', source: '' } });
						this.showNext = false;
					}
				} else {
					this.setState({ nextLocation: { location: '', source: '' } });
					this.showNext = false;
				}
				if (this.state.prevLocation.source)
					this.showPrev = true;
				else
					this.showPrev = false;
				break;
		}
	}
	countryRegionList = (dataArray) => {
		if (dataArray && dataArray.length) {
			return dataArray.map((item, index) => {
				return <span>{item.country_name}{(dataArray.length - 1) == index ? '' : ','} </span>

			})
		} else {
			return []
		}
	}
	render(props) {
		let isProjectDetailNonEmpty = Object.keys(this.props.projectDetail.project).length > 0;
		const data = (this.props.mapCountryData.outputData.data) ? (this.props.mapCountryData.outputData.data[0]) : [];
		return (
			<div class={style.container} style={{ paddingTop: "15px" }}>
				<p style={{ color: '#191818', fontWeight: "600", marginLeft: "1.4%" }}> Project ID: {this.props.projectDetail && this.props.projectDetail.project.project_id}  &nbsp;  Project Status: {this.props.projectDetail && this.props.projectDetail.project && this.props.projectDetail.project.status} </p>
				<div style={{ width: '100%', display: 'flex' }}>
					<div style={{ width: '50%', paddingRight: '2%' }}>
						<div class={'col-md-12 col-sm-12 col-xs-12'} style={{ position: 'static' }}>
							<div class={style.description}>
								<p class={style.heading}>Summary </p>
								<div style={{ position: 'absolute' }}>
									<a onClick={() => this.setState({ showText: !this.state.showText })}>
										{this.state.showText ? <div class={style.cssCircle}>
											<span class={style.minusSign}>&#8211;</span>
										</div> : <div class={style.cssCircle}>
											<span class={style.plusSign}>&#43;</span>
										</div>}

									</a>
								</div>
								<div style={{ marginLeft: '8%' }}>
									{!this.state.showText ? <span style={{ color: '#191818' }}>{this.props.projectDetail.project.description && this.props.projectDetail.project.description.split(" ").splice(0, 9).join(" ")}  </span>
										: null}
									{this.state.showText ? <p>
										{this.props.projectDetail.project.description.split('\n').map((item, key) => {
											return <span key={key}>{item}<br /></span>
										})}
										{/* {this.props.projectDetail.project.description.replace(/(?:\r\n|\r|\n)/g, '<br />')} */}
									</p>
										: null}
								</div>

							</div>




							<div class={style.projectStatus}>

								<ProjectTimeLine data={this.props.projectDetail.time_line} />
								<div className={style.arealChart}>
									<div className={style.heading} style={{ marginTop: '10px', marginTop: '25px' }}>
										<span>Budget Utilisation</span>
									</div>
									<div className={style.areaHeaderWrapper}>

										<div className={style.legendWrapper}>

											<div className={style.legendItemOuterWrapper}>

												<div className={style.legendItemInnerWrapper}>
													<div className={style.itemAlignmentWrapper}>
														<span class={`${style.legend} ${style.budgetLegend} `} />
														<span>Budget</span>
													</div>

												</div>
												<div className={style.legendItemInnerWrapper}>
													<div className={style.itemAlignmentWrapper}>
														<span class={`${style.legend} ${style.revenueLegend} `} />
														<span>Expenditure</span>
													</div>

												</div>
											</div>
										</div>
									</div>
									<AreaChartView />
								</div>
							</div>
						</div>
					</div>
					<div style={{ width: '50%' }}>
						<section >
							{(this.state.expand) ?
								(this.state.mapType !== 'map') ?
									<DownloadModal onCloseModal={() => this.closeModal()} mapType={this.state.mapType} satelliteData={this.props.satelliteData} currentLocationIndex={this.currentLocationIndex} changeSource={(index) => this.changeSatelliteSrc(index)} />
									// <DownloadModal onCloseModal={() => this.closeModal()} mapType = {this.state.mapType} projectId={this.props.projectId} projectDetailMapData = {data} />
									: <DownloadModal onCloseModal={() => this.closeModal()} mapType={this.state.mapType} projectId={this.props.projectId} projectDetailMapData={props.projectDetailMapData} />
								: null
							}

						</section>
						{
							isProjectDetailNonEmpty &&
							<div class={'col-md-12 col-sm-12 col-xs-12'}>
								<Helmet
									meta={[
										{ name: 'description', content: this.props.projectDetail.project.description },
										{ property: 'og:description', content: this.props.projectDetail.project.description },
										{ property: 'twitter:description', content: this.props.projectDetail.project.description }
									]}
								/>
								<div class={`${style.descriptionSection}`}>
									<div class={style.description}>
										{
											this.props.projectDetail.project.description_type2 ?
												<div>
													<p class={style.heading}>Objectives</p>
													<div style={{ position: 'absolute' }}>
														<a onClick={() => this.setState({ showTextDesc2: !this.state.showTextDesc2 })}>
															{this.state.showTextDesc2 ? <div class={style.cssCircle}>
																<span class={style.minusSign}>&#8211;</span>
															</div> : <div class={style.cssCircle}>
																<span class={style.plusSign}>&#43;</span>
															</div>}

														</a>
													</div>
													<div style={{ marginLeft: '6%' }}>
														{!this.state.showTextDesc2 ? <span style={{ color: '#191818' }}>{this.props.projectDetail.project.description_type2 && this.props.projectDetail.project.description_type2.split(" ").splice(0, 9).join(" ")}  </span>
															: null}
														{this.state.showTextDesc2 ? <p>
															{this.props.projectDetail.project.description_type2.split('\n').map((item, key) => {
																return <span key={key}>{item}<br /></span>
															})}
															{/* {this.props.projectDetail.project.description_type2} */}
														</p>
															: null}
													</div>
												</div>


												: null}
									</div>

									<div class={style.mapArea}>
										<div class={style.description} style={{ margin: '0px', paddingBottom: '20px', borderTopLeftRadius: '14px', borderTopRightRadius: '14px', borderBottomLeftRadius: '0px', borderBottomRightRadius: '0px' }}>
											<p class={style.heading}>Recipient Country / Region
												<section class={style.mapOptions} style={{ position: 'relative', float: 'right' }}>
													<section class={style.mapMenu} >
														<img class={style.expandButton} src='./../../static/assets/icons/expand.svg' onClick={() => this.openModal(this.state.mapType)} />
													</section>
												</section>
											</p>
											{this.countryRegionList(this.props.mapCountryData && this.props.mapCountryData.outputData && this.props.mapCountryData.outputData.data)}
										</div>
										<div style={{ 'padding-top': '0px' }} class={style.projectMap}>
											{
												this.state.mapType === 'map' ?
													<Map
														clusterMode
														projectId={this.props.projectId}
														mapData={this.props.projectDetailMapData}
														mapId={'individualProjectMap'}
														autoCenter
													/>
													:
													this.props.satelliteData.length ?

														<div>SATELLITE DATA TEXT</div>
														:
														<div>
															FINAL CONDITION
														</div>
											}

										</div>
										<div class={style.disclaimer}>
											{'* The designations employed and the presentation of material on this map do not imply the expression of any opinion whatsoever on the part of IUCN concerning the legal status of any country, territory, city or area or its authorities, or concerning the delimitation of its frontiers or boundaries.'}
										</div>
									</div>
									<div class={style.description}>
										<p class={style.heading}>Implementing Partners</p>
										{this.props.projectDetail.project && this.props.projectDetail.project.organisation && this.props.projectDetail.project.organisation['iucn_members'].length > 0 ?
											<div>
												<a onClick={() => this.setState({ iucnMember: !this.state.iucnMember })}>
													{this.state.iucnMember ? <div class={style.cssCirclePartner}>
														<span class={style.minusSign}>&#8211;</span>
													</div> : <div class={style.cssCirclePartner}>
														<span class={style.plusSign}>&#43;</span>
													</div>}<p style={{ marginLeft: '33px', 'postions': 'absolute', color: '#000' }}>IUCN member</p>
												</a>
												{this.state.iucnMember ? <span>{this.props.projectDetail.project && this.props.projectDetail.project.organisation && this.props.projectDetail.project.organisation['iucn_members'].join(', ')
												}</span> : null}
											</div>
											: null}
										{this.props.projectDetail.project && this.props.projectDetail.project.organisation && this.props.projectDetail.project.organisation['iucn_nonmembers'].length > 0 ?
											<div>
												<a onClick={() => this.setState({ iucnNonMember: !this.state.iucnNonMember })}>
													{this.state.iucnNonMember ? <div class={style.cssCirclePartner}>
														<span class={style.minusSign}>&#8211;</span>
													</div> : <div class={style.cssCirclePartner}>
														<span class={style.plusSign}>&#43;</span>
													</div>}<p style={{ marginLeft: '33px', 'postions': 'absolute', color: '#000' }}>IUCN non member</p>
												</a>
												{this.state.iucnNonMember ? <span>{this.props.projectDetail.project && this.props.projectDetail.project.organisation && this.props.projectDetail.project.organisation['iucn_nonmembers'].join(', ')}</span> : null}
											</div>
											: null}
									</div>
								</div>

							</div>

						}
					</div>
				</div>


			</div>

		);
	}
}
const mapStateToProps = (state) => {
	const { projectDetailMapData } = state.mapData;
	const mapCountryData = state.mapData;
	return {
		projectDetail: state.projectDetail,
		projectDetailMapData,
		mapCountryData
	};
};

const mapDispatch = (dispatch) => ({
})

export default connect(mapStateToProps, mapDispatch)(ProjectDescription);



// WEBPACK FOOTER //
// ./components/projectDescription/index.js